import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { trackPageView } from "@/lib/analytics";

import { Navbar } from "@/components/sections/Navbar";
import { HeroSection } from "@/components/sections/HeroSection";
import { ProblemsSection } from "@/components/sections/ProblemsSection";
import { ServiceSection, MethodologySection } from "@/components/sections/ServiceSection";
import { PricingSection } from "@/components/sections/PricingSection";
import { MantenimientoSection } from "@/components/sections/MantenimientoSection";
import { FaqSection, FinalCtaSection } from "@/components/sections/FaqSection";
import { Footer } from "@/components/sections/Footer";
import { ContactoRapidoForm } from "@/components/forms/ContactoRapidoForm";
import { DiagnosticoForm } from "@/components/forms/DiagnosticoForm";
import { LeadMagnetModal } from "@/components/modals/LeadMagnetModal";
import { PrivacyModal, AiTransparencyModal, LegalNoticeModal, CookiePolicyModal } from "@/components/modals/LegalModals";
import { FloatingCTA } from "@/components/FloatingCTA";
import { CookieConsent } from "@/components/CookieConsent";

export default function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [leadModalOpen, setLeadModalOpen] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [aiTransparencyModalOpen, setAiTransparencyModalOpen] = useState(false);
  const [legalModalOpen, setLegalModalOpen] = useState(false);
  const [cookieModalOpen, setCookieModalOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  const openPrivacy = () => setPrivacyModalOpen(true);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    trackPageView("/");
    const target = searchParams.get("to");
    if (target) {
      setTimeout(() => {
        document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
        setSearchParams({}, { replace: true });
      }, 500);
    }
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#101421' }}>
      <Toaster position="top-center" richColors theme="dark" />

      <Navbar scrollToSection={scrollToSection} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <HeroSection scrollToSection={scrollToSection} />
      <ProblemsSection />
      <ServiceSection />
      <MethodologySection />
      <PricingSection scrollToSection={scrollToSection} />

      <section id="diagnostico" className="section-dark" data-testid="diagnostic-section">
        <div className="container-custom">
          <ContactoRapidoForm onOpenPrivacy={openPrivacy} />
          <DiagnosticoForm onOpenPrivacy={openPrivacy} />
        </div>
      </section>

      <MantenimientoSection scrollToSection={scrollToSection} />
      <FaqSection />
      <FinalCtaSection scrollToSection={scrollToSection} />
      <Footer
        scrollToSection={scrollToSection}
        onOpenLegal={() => setLegalModalOpen(true)}
        onOpenPrivacy={openPrivacy}
        onOpenTransparency={() => setAiTransparencyModalOpen(true)}
        onOpenCookies={() => setCookieModalOpen(true)}
      />

      <LeadMagnetModal open={leadModalOpen} onOpenChange={setLeadModalOpen} />
      <PrivacyModal open={privacyModalOpen} onOpenChange={setPrivacyModalOpen} />
      <AiTransparencyModal open={aiTransparencyModalOpen} onOpenChange={setAiTransparencyModalOpen} />
      <LegalNoticeModal open={legalModalOpen} onOpenChange={setLegalModalOpen} />
      <CookiePolicyModal open={cookieModalOpen} onOpenChange={setCookieModalOpen} />
      <CookieConsent />
      <FloatingCTA scrollToSection={scrollToSection} />
    </div>
  );
}
